import { IDefineCommand } from 'core-ts-types';
import { INotificationDelegate } from '../../global/helpers/notification_delegate';
import {
  FeedbackSuggestedPlanModel,
  IFeedbackSuggestedPlanModel
} from '../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';

angular
  .module('capability-ng-academic-planner')
  .factory(
    'createEmptySuggestedPlanCommand',
    function createEmptySuggestedPlanCommandDefinition(
      $http: ng.IHttpService,
      defineCommand: IDefineCommand,
      ngAPNotificationDelegate: INotificationDelegate,
      ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel,
      log: any
    ) {
      return defineCommand(
        'createEmptySuggestedPlanCommand',
        function createEmptySuggestedPlanCommand(deferred, showSuccessNotification: boolean = true) {
          $http
            .post('academicplan/suggested_plan/create/', {})
            .then((response: any) => {
              ngFeedbackSuggestedPlanModel.clear().write(response.data);
              if (showSuccessNotification) {
                ngAPNotificationDelegate.success('Successfully created a new draft of suggestions.');
              }
              ngFeedbackSuggestedPlanModel.clear().write(response.data);
              deferred.resolve(response.data);
            })
            .catch((e) => {
              ngAPNotificationDelegate.error(`Unable to create a new draft of suggestions: ${e.data.detail}`);
              log.error(e);
              deferred.reject(e);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/advisor_header/commands/create_empty_suggested_plan_command.ts